// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'farming-wheat';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M7.3 5.356c0 1.708 1.688 3.093 1.688 3.093s1.688-1.385 1.688-3.093-1.688-3.094-1.688-3.094-1.687 1.384-1.687 3.094zm.487 2.054c1.392 1.392 1.2 3.84 1.2 3.84s-2.448.19-3.84-1.2-1.2-3.84-1.2-3.84 2.447-.192 3.84 1.2z' />
    <path d='M10.19 7.41c-1.392 1.392-1.2 3.84-1.2 3.84s2.448.19 3.84-1.2 1.2-3.84 1.2-3.84-2.447-.192-3.84 1.2zm-2.403 5.062c1.392 1.392 1.2 3.84 1.2 3.84s-2.448.19-3.84-1.2-1.2-3.84-1.2-3.84 2.447-.192 3.84 1.2z' />
    <path d='M10.19 12.472c-1.392 1.392-1.2 3.84-1.2 3.84s2.448.19 3.84-1.2 1.2-3.84 1.2-3.84-2.447-.192-3.84 1.2zm-1.202 3.841v1.125M3.947 6.208v-2.25m10.083 2.25v-2.25M8.988 2.262V.574' />
  </g>
);

export const viewBox = '0 0 18 18';
